import { render } from "./HeatSection.vue?vue&type=template&id=5902d939&scoped=true"
import script from "./HeatSection.vue?vue&type=script&lang=js"
export * from "./HeatSection.vue?vue&type=script&lang=js"

import "./HeatSection.vue?vue&type=style&index=0&id=5902d939&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5902d939"]])

export default __exports__